// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import {
  FactoryWithChoiceContext,
  GetFactoryRequest,
} from '@digitalasset/allocation-instruction-api-ts-client';
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { AllocationSpecification } from '@daml.js/splice-api-token-allocation/lib/Splice/Api/Token/AllocationV1';
import { Holding } from '@daml.js/splice-api-token-holding/lib/Splice/Api/Token/HoldingV1';
import { ContractId } from '@daml/types';
import { useAllocationInstructionApiClient } from '../../../contexts/AllocationInstructionApiContext';

export const useAllocationFactoryWithContext: () => UseMutationResult<
  FactoryWithChoiceContext,
  string,
  {
    registrar: string;
    allocation: AllocationSpecification;
    inputHoldings: ContractId<Holding>[];
  }
> = () => {
  const allocationInstructionApi = useAllocationInstructionApiClient();

  return useMutation({
    mutationKey: ['allocationFactoryWithContext', allocationInstructionApi],
    mutationFn: async ({ registrar, allocation, inputHoldings }) => {
      const request = {
        choiceArguments: {
          expectedAdmin: registrar,
          allocation,
          requestedAt: allocation.settlement.requestedAt,
          inputHoldingCids: inputHoldings,
          extraArgs: { context: { values: {} }, meta: { values: {} } },
        },
        excludeDebugFields: true,
      } as GetFactoryRequest;
      return allocationInstructionApi.getAllocationFactory(registrar, request);
    },
    retry: false,
  });
};
